const formattedWallet = (account) => {
  const address = account.split("");
  const wallet =
    address[0] +
    address[1] +
    address[2] +
    address[3] +
    address[4] +
    address[5] +
    "..." +
    address[38] +
    address[39] +
    address[40] +
    address[41];
  return wallet;
};

export { formattedWallet };
